//core
import React from "react";
import { Box } from "@mui/material";

//styles
import { useStyles } from "./styles";

//components
import Wallet from "./components/Wallet";

interface IAgentWalletsProps {
  data: any;
}


const AgentWallets: React.FC<IAgentWalletsProps> = ({
  data,
}): React.ReactElement => {
  const styles = useStyles();

  return (
    <>
      {data.wallets.length > 0 ? (
        <Box className={styles.block}>
          {data.wallets.map((el: any, i: number) => {
            return (
              <Wallet
                key={`${el.operator}-${el.brand}-${el.currency}-${i}`}
                wallet={el}
                agentId={data.id}
              />
            )
          })}
        </Box>
      ) : <>
        {'—'}
      </>}
    </>

  );
};

export default AgentWallets;
